var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shopMobTop"},[_c('div',{staticClass:"top"},[_c('img',{attrs:{"src":require('@/common/images/shop/view-top.png'),"alt":""}}),_c('div',{staticClass:"shopName"},[_vm._v(_vm._s(_vm.smallPageName))])])])}
var staticRenderFns = []

export { render, staticRenderFns }